import { Observable } from "rxjs";

import * as http from "../../../../../../../../../services/http.service";
import { SearchResults } from "../../../../../../../../../types/search/search-results.interface";

import { PositionCategory } from "../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

export function searchPositionCategories(
  searchText: string
): Observable<SearchResults<PositionCategory>> {
  return http.get(`/search/position-categories/?q=${searchText}`);
}
